import { AboutPage } from '../components/pages'

export default AboutPage
